import { StyleSheet } from 'react-native';
import React from 'react'
import { DataItemStyles } from 'styles/components/atoms/DataItem'
import DataItem from 'components/atoms/DataItem'
import ThemedBlock from 'components/atoms/ThemedBlock'
import i18n from 'utils/i18n'
import { colorList } from 'utils/colors'
import Icon from 'components/atoms/Icon'
import { IconSystemConstants } from 'utils/constants/IconNameConstants'


const ThemedHint = ({ title = null, hint = null, icon = null }) => {
	
	if( title === null ){
		title = i18n.t( 'hints.title' );
	}
	if( icon === null ){
		icon = <Icon icon={ IconSystemConstants.INFO } style={ [ DataItemStyles.headerIcon ] } />;
	}
	
	return (
		<ThemedBlock shadow smallPadding smallMargin style={ staticStyles.themedBlockBorderColorPrimary }>
			<DataItem
				content={ hint }
				icon={ icon }>
				
				{ title }
			</DataItem>
		</ThemedBlock>
	)
}

const staticStyles = StyleSheet.create({
	themedBlockBorderColorPrimary: {
		borderColor: colorList.ORANGE.primary,
	},
});

export default ThemedHint
